import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const DSA_RATING_SORT_AB_TEST_ID = "algorytmic_listing_sort";
export const DSA_RATING_SORT_CONTROL_VARIANT = "control" as const;
export const DSA_RATING_SORT_TREATMENT_VARIANT = "algorytmic_listing" as const;

/**
 * A/B test managed by Amplitude Experiment. The Amplitude flag must expose `control` and `algorytmic_listing` variants.
 * `control` keeps the previous default sorting untouched, `algorytmic_listing` defaults offer listings to `dsa_rating`
 * sorting whenever the user hasn't picked a sort explicitly.
 * Override in dev: ?ab_test_experiment=algorytmic_listing_sort&ab_test_variant=algorytmic_listing|control
 */
export const dsaRatingSortAbTest: IABTestConfiguration = {
    id: DSA_RATING_SORT_AB_TEST_ID,
    name: OngoingABTests.DSA_RATING_SORT,
    expires: new Date(2027, 0, 1),
    path: rpAppPath.base,
    variants: [DSA_RATING_SORT_CONTROL_VARIANT, DSA_RATING_SORT_TREATMENT_VARIANT],
    withSSR: true,
    matchOnAllPaths: true,
    useAmplitude: true
};

export const isDsaRatingSortTreatmentVariant = (variant: string | null | undefined): boolean => variant === DSA_RATING_SORT_TREATMENT_VARIANT;
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {OngoingABTests} from "./ongoing_ab_tests_enum";

export const DSA_RATING_SORT_AB_TEST_ID = "algorytmic_listing_sort";
export const DSA_RATING_SORT_CONTROL_VARIANT = "control" as const;
export const DSA_RATING_SORT_TREATMENT_VARIANT = "algorytmic_listing" as const;

/**
 * A/B test managed by Amplitude Experiment. The Amplitude flag must expose `control` and `algorytmic_listing` variants.
 * `control` keeps the previous default sorting untouched, `algorytmic_listing` defaults offer listings to `dsa_rating`
 * sorting whenever the user hasn't picked a sort explicitly.
 * Override in dev: ?ab_test_experiment=algorytmic_listing_sort&ab_test_variant=algorytmic_listing|control
 */
export const dsaRatingSortAbTest: IABTestConfiguration = {
    id: DSA_RATING_SORT_AB_TEST_ID,
    name: OngoingABTests.DSA_RATING_SORT,
    expires: new Date(2027, 0, 1),
    path: rpAppPath.base,
    variants: [DSA_RATING_SORT_CONTROL_VARIANT, DSA_RATING_SORT_TREATMENT_VARIANT],
    withSSR: true,
    matchOnAllPaths: true,
    useAmplitude: true
};

export const isDsaRatingSortTreatmentVariant = (variant: string | null | undefined): boolean => variant === DSA_RATING_SORT_TREATMENT_VARIANT;
